import { render, staticRenderFns } from "./UserTeamAdd.vue?vue&type=template&id=6aaa524a&scoped=true&"
import script from "./UserTeamAdd.vue?vue&type=script&lang=js&"
export * from "./UserTeamAdd.vue?vue&type=script&lang=js&"
import style0 from "./UserTeamAdd.vue?vue&type=style&index=0&id=6aaa524a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaa524a",
  null
  
)

export default component.exports